import React from 'react';
import checkFieldValidity from './checkFieldValidity';
import createUUID from './createUUID';
import {useTranslation} from 'react-i18next';

const useOnFieldChange = (fieldsGroup, setFieldsGroup) => {
    const {t} = useTranslation();

    return (value, field) => {
        let valid = false;
        let errors = [];
        let errorsFragment = [];
        let newFieldsGroup;
        let equalsFieldObj;
        let equalsFieldValid;
        let equalsFieldErrors = []
        let equalsFieldErrorsFragment = []


        if (fieldsGroup.fields[field].validate) {
            equalsFieldObj = fieldsGroup.fields[field].rules.find(rule => rule.type === 'equalsField');
            const validity = checkFieldValidity(value, fieldsGroup.fields[field].rules, t);
            valid = validity.valid;
            errors = [...validity.errors];

            if (typeof equalsFieldObj !== 'undefined') {
                const equalsFieldValidity = checkFieldValidity(fieldsGroup.fields[equalsFieldObj.fieldName].value, fieldsGroup.fields[equalsFieldObj.fieldName].rules, t);
                equalsFieldValid = equalsFieldValidity.valid;
                equalsFieldErrors = [...equalsFieldValidity.errors]

                for (let error of equalsFieldErrors) {
                    equalsFieldErrorsFragment.push(<p className="mb-0" key={createUUID()}>{error}</p>)
                }

                if (value !== fieldsGroup.fields[equalsFieldObj.fieldName].value && fieldsGroup.fields[equalsFieldObj.fieldName].touched) {
                    errors.push(t('checkFieldValidity.fields-equal'));
                    valid = false;
                }
            };

            for (let error of errors) {
                errorsFragment.push(<p className="mb-0" key={createUUID()}>{error}</p>)
            }
        }

        let othersValid = true;
        for (let [key, value] of Object.entries({...fieldsGroup.fields})) {
            if (typeof equalsFieldObj !== 'undefined') {
                if (field !== key && field !== equalsFieldObj.fieldName && value.validate) {
                    othersValid = (othersValid && value.valid && fieldsGroup.fields[equalsFieldObj.fieldName].valid);
                }
            } else {
                if (field !== key && value.validate) {
                    othersValid = (othersValid && value.valid);
                }
            }
        }

        let touched = fieldsGroup.fields[field].validate;
        if (fieldsGroup.fields[field].rules.find((rule) => rule.type === 'validOnEmpty') && value.length === 0) {
            touched = false;
        }

        if (equalsFieldObj) {
            console.log(othersValid);
            newFieldsGroup = {
                ...fieldsGroup,
                touched: true,
                valid: othersValid && valid,
                fields: {
                    ...fieldsGroup.fields,
                    [field]: {
                        ...fieldsGroup.fields[field],
                        value,
                        valid,
                        touched,
                        errors,
                        errorsFragment
                    },
                    [equalsFieldObj.fieldName]: {
                        ...fieldsGroup.fields[equalsFieldObj.fieldName],
                        valid: equalsFieldValid,
                        touched: fieldsGroup.fields[equalsFieldObj.fieldName].touched,
                        errors: equalsFieldErrors,
                        errorsFragment: equalsFieldErrorsFragment
                    }
                }
            };
        } else {
            newFieldsGroup = {
                ...fieldsGroup,
                valid: othersValid && valid,
                touched: true,
                fields: {
                    ...fieldsGroup.fields,
                    [field]: {
                        ...fieldsGroup.fields[field],
                        value,
                        valid,
                        touched,
                        errors,
                        errorsFragment
                    }
                }
            };
        }

        setFieldsGroup(newFieldsGroup);
    }
}

export default useOnFieldChange;
